"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCardsLayout = exports.findCardById = exports.getDuplicateCardData = exports.getEmptyCard = void 0;
const utils_1 = require("../../utils/utils");
const constants_1 = require("./constants");
const getEmptyCard = (cardType) => {
    const id = (0, utils_1.generateUUID)();
    return {
        position: { ...constants_1.EMPTY_CARD.position, i: id },
        component: {
            ...constants_1.EMPTY_CARD.component,
            id,
            type: cardType,
        },
    };
};
exports.getEmptyCard = getEmptyCard;
const getDuplicateCardData = (cardData) => {
    const id = (0, utils_1.generateUUID)();
    return ({
        ...cardData,
        position: { ...cardData.position, i: id },
        component: { ...cardData.component, id },
    });
};
exports.getDuplicateCardData = getDuplicateCardData;
const findCardById = (cards, cardId) => cards.find((card) => card.component?.id === cardId);
exports.findCardById = findCardById;
const updateCardsLayout = (layouts, cardsData) => {
    const cards = [];
    layouts.forEach((layout) => {
        const card = (0, exports.findCardById)(cardsData, layout.i);
        if (!card) {
            return;
        }
        cards.push({
            ...card,
            position: {
                i: layout.i,
                x: layout.x,
                y: layout.y,
                w: layout.w,
                h: layout.h,
                minH: layout.minH,
                maxH: layout.maxH,
                minW: layout.minW,
                maxW: layout.maxW,
            },
        });
    });
    return cards;
};
exports.updateCardsLayout = updateCardsLayout;
//# sourceMappingURL=helpers.js.map